module.exports = __webpack_public_path__ + "img/mail.d872f98c.svg";